export default class CDSUploadAdapter {
	constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        console.log(loader);
    }

    // Starts the upload process.
    upload() {
        var apiEndpoint = (process.env.NODE_ENV == 'development') ? "https://flightdeck.test/" : document.location.origin + "/api/"
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
				var hrefParts = window.location.href.split('/')
				var formData = new FormData();
				formData.append('source', 'DASHBOARD')
				formData.append('context', 'KNOWLEDGEBASE')
				formData.append('kb_item_id', hrefParts.pop())
				formData.append('upload_file', file);
				let headers = {
					method: 'post',
					body: formData,
					credentials: 'include'
				}
				fetch(apiEndpoint + 'api.php?action=upload_dashboard_image', headers).then(function(response) {
					return response.json()
				}).then(obj => {
					if (obj.image_src) {
						resolve({
		                	default: obj.image_src
			            })
						success()
					} else {
						reject(obj.message)
					}
				}).catch(error => {
					reject(error)
				})
            } ) );
    }

    // Aborts the upload process.
    abort() {
        // Do nothing???
    }
}
